@if(loading$ | async) {
<app-loading
  class="h-100 w-100 loading-container"
  [text]="'Loading'"
></app-loading>
} @else {
<div class="container-fluid d-flex flex-column">
  <!-- @if(this.folders?.length || this.scripts.length > 1) { -->
  <div class="button-list" *ngIf="addButtonText!==''">
    <button
      class="release-btn btn-accello-secondary"
      (click)="addNewComponent()"
    >
      <img
        [src]="'images/virtusa-icons/add-icon-dark.svg' | assetUrl"
        alt="Add Icon"
        width="18"
        height="18"
      />
      {{ addButtonText }}
    </button>

    <button
      class="release-btn btn-accello-light"
      (click)="removeComponents()"
      [disabled]="!selectedComponents.length"
      (focus)="changeRemoveIcon(false)"
      (mouseenter)="changeRemoveIcon(false)"
      (mouseleave)="changeRemoveIcon(false)"
      (blur)="changeRemoveIcon(false)"
      (mousedown)="changeRemoveIcon(true)"
      (mouseup)="changeRemoveIcon(false)"
    >
      <img [src]="iconSrcDelete | assetUrl" width="18" height="18" />
      <span> {{ removeButtonText }} </span>
      @if(isLoading){
        <span class="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
      }
    </button>
    <button class="btn-accello-ternary" (click)="refreshData()">
      <img src="assets/images/virtusa-icons/sync.svg" alt="refresh" />
      <span>Refresh</span>
    </button>
  </div>
   @if(this.folders?.length) {

  <div class="d-flex flex-column mb-4">
    <div class="header-wrapper">
      <span class="accello-general-text14">Reusable Components Folders</span>
    </div>
    <div class="custom-card">
      <app-script-card-tile
        class="w-100"
        [cardList]="folders"
        (selectedCardsChange)="handleSelectedCards($event)"
        (onEditClick)="onEditFolder($event)"
      ></app-script-card-tile>
    </div>
  </div>
  }

  <div class="d-flex flex-column">
    @if(this.isFolder){
      <div class="d-flex flex-row">
        <div class="page-tab d-flex gap-3">
          <div class="name-div"><span class="accello-general-text2 pg-sp">Component Folder Name</span>
            <span class="accello-general-text13">{{
              selectedFolder?.name
            }}</span></div>
        </div>
      </div>
    } @else{
      <div class="header-wrapper">
        <span class="accello-general-text14">Reusable Components</span>
      </div>
    }
    
    <div class="reusable-wrapper">
      <app-zorro-table
        tableId="ru-compo"
        [data]="scripts"
        [columns]="columns"
        [options]="{ expandable: true }"
        (onRowSelect)="handleRowSelect($event)"
        (handleActions)="handleTableActions($event)"
      ></app-zorro-table>
    </div>
  </div>
</div>
}
